import React, { useState, useEffect } from 'react';
import './NavBar.scss';
import { motion, AnimatePresence, AnimateSharedLayout } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../shampoo/UserConditionsTemplate/ScalpType/Tooltip';
import logEvent from '../../../utils/logEvent';
import styles from './NavBar.module.scss';

import { useSelector } from 'react-redux';

import cx from 'classnames';

import {
  IconHome,
  IconForeheadDiagnosis,
  IconScalpDiagnosis,
  IconShampooIcon,
  FocusedIconForeheadDiagnosis,
  FocusedIconHome,
  FocusedIconScalpDiagnosis,
  FocusedIconShampooIcon,
} from './assets';

const NavBar = ({ firstOpen, navTab, setNavTab, checkFirstOpen }) => {
  const { pageType } = useSelector(({ status }) => ({
    pageType: status.pageType,
  }));

  const { t } = useTranslation('utilsV2');
  const navList = [
    'main',
    'scalp',
    'solution',
    'forehead',
    // telemedicine
  ];

  const findNavIcon = (navTitle) => {
    return {
      main: <IconHome />,
      scalp: <IconScalpDiagnosis />,
      forehead: <IconForeheadDiagnosis />,
      solution: <IconShampooIcon />,
    }[navTitle];
  };
  const findNavFocusedIcon = (navTitle) => {
    return {
      main: <FocusedIconHome />,
      scalp: <FocusedIconScalpDiagnosis />,
      forehead: <FocusedIconForeheadDiagnosis />,
      solution: <FocusedIconShampooIcon />,
    }[navTitle];
  };

  // const [tooltipVisible, setTooltipVisible] = useState(null);

  // useEffect(() => {
  //   if (tooltipVisible) {
  //     const timer = setTimeout(() => {
  //       setTooltipVisible(null);
  //     }, 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [tooltipVisible]);

  const onNavClick = (nav, newNavTab) => {
    checkFirstOpen();
    // logEvent({
    //   ga: {
    //     eventName: 'select_content',
    //     eventParam: {
    //       content_type:
    //         newNavTab === 0
    //           ? 'menu_shampoo'
    //           : newNavTab === 1
    //             ? 'menu_m_diagnosis'
    //             : newNavTab === 2
    //               ? 'menu_scalp_diagnosis'
    //               : 'menu_promotion',
    //     },
    //   },
    // });
    // const tabIdx = process.env.REACT_APP_SERVER_BASE_URL === 'stg' ? 2 : 1;
    // const tabIdx = 2;
    // if (newNavTab > tabIdx) {
    //   setTooltipVisible(nav);
    //   return;
    // }
    setNavTab(newNavTab);
  };

  return (
    <>
      {pageType === 'main' && (
        <div className={styles.navBarWrapper}>
          <div className={styles.navBarContainer}>
            {navList.map((nav, index) => {
              return (
                <div
                  key={`key_${nav}`}
                  onClick={() => onNavClick(nav, index)}
                  className={styles.navItem}
                >
                  {navTab === index
                    ? findNavFocusedIcon(nav)
                    : findNavIcon(nav)}
                  <div
                    className={cx(styles.iconAltText, {
                      [styles.active]: navTab === index,
                    })}
                  >
                    {t(`navMenu.${nav}`)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>

    // <div className="navBar bg_paleLavender">
    //   <div className="navList">
    //     <AnimateSharedLayout>
    //       {navList.map((nav, index) => (
    //         <div
    //           key={index}
    //           onClick={() => onNavClick(nav, index)}
    //           className={`nav text_brownGrey ${
    //             navTab === index ? 'active font_bold' : 'font_regular'
    //           }`}
    //         >
    //           {nav}
    //           {navTab === index ? (
    //             firstOpen ? (
    //               <span></span>
    //             ) : (
    //               <motion.span layoutId="activeNav"></motion.span>
    //             )
    //           ) : null}
    //           {/* <AnimatePresence>
    //             {tooltipVisible === nav && (
    //               <Tooltip direction="right">Comming Soon!</Tooltip>
    //             )}
    //           </AnimatePresence> */}
    //         </div>
    //       ))}
    //     </AnimateSharedLayout>
    //   </div>
    // </div>
  );
};

export default NavBar;
